import React, { Component } from 'react';
import ScreenContainer from '../../ui/ScreenContainer';
import SimpleEditGrid from '../../ui/EditGrid/SimpleEditGrid.js';
import Button from '@mui/material/Button';
import UiButton from '../../ui/Button';
import _ from 'lodash';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import "../../../index.css";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import EndProcessAction from './EndProcessAction';
import * as apiDashBoardService from '../apiRequestService';
import {getProcessGroups} from '../../ProcessGroup/apiRequestService';
import {getProcessType} from '../../ProcessType/apiRequestService';
import {getParameterByGroupCode,getParametersByGroupCodes} from '../../Parameter/apiRequestService';
import styles from '../../../style.js';
import {getUsers} from '../../NewProcess/apiRequestService';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

class NewProcessTemplate extends Component {
 

  constructor(props) {
    super(props);
    this.guidEmpty = '00000000-0000-0000-0000-000000000000';

    this.state = {
      id:'',
      editModelPage:false,
      templateName:'',
      processGroup:this.guidEmpty,
      processType:this.guidEmpty,
      processGroupsList : [],
      processTypesList : [],
      fileReadValidationCheck:false,
      signOrder:1,
      sufficientSigner:0,
      sufficientSignerList : [],
      internalSigners:[],
      internalSignersColumns : [
        { field: 'id', hide: true },
        { field: 'userInfo',headerName:'Kullanıcı',type:'singleSelect',labelText:'Kullanıcı', width: 428,
        renderCell: (params) => (<div>{params.value.fullName}</div>),
        dataList:[],keyField:'id',valueField:'fullName'},
        { field: 'signType',headerName:'İmzalama Türü',type:'singleSelect',labelText:'İmzalama Türü', width: 428,
        renderCell: (params) => (<div>{params.value.parameterName}</div>),
        dataList:[],keyField:'parameterValue',valueField:'parameterName'},
        { field: 'recordStatus', hide: true }
      ],
      internalSignersColumnsVisiblity:{id:false,recordStatus:false},
      notificationType:0,
      notificationTypesList:[],
      endProcessNotificationType:0,
      endProcessNotificationTypeList:[],
      endOperationAction:{},
      endProcessActionsList:[],
      isEndProcessLoaded:false,
      parameterGroups:['SUFFICIENT_NUMBER_OF_SIGNERS','SIGN_TYPE','NOTIFICATION_TYPE','END_PROCESS_NOTIFICATION','COMPLETED_PROCESS']
    };
  }

  componentDidMount() {
    const {parameterGroups}=this.state;

    let selectedValue={};
    if (this.props !== undefined && this.props.editPage) {
    const { selectedId, data } = this.props;

      for (let i = 0; i < data.length; i++) {
        let value=data[i];
        if (value.id === selectedId) {
          selectedValue=value;
          this.setState({
            editModelPage: true,
            id: value.id,
            templateName: value.name,
            processGroup:value.processGroup,
            processType:value.processType,
            fileReadValidationCheck: value.isReadBeforeSign,
            signOrder: value.signOrder,
            sufficientSigner: value.sufficientSigner,
            internalSigners:value.internalSigners,
            notificationType:value.notificationType,
            endProcessNotificationType:value.endProcessNotificationType,
            endOperationAction:value.endOperationAction
          });
        }
      }
    }

    //Süreç Grubu
    getProcessGroups()
    .then((response) => {
      this.setState({processGroupsList : response.data});

      //Süreç Türü 
      let processGrpId=this.state.processGroup;
      if(processGrpId!=1)
        this.fillProcessTypeList(processGrpId);
    })
    .catch((exception) => {
      this.props.actions.setNotification("Süreç grubu bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getProcessGroups exception: ' + JSON.stringify(exception));
    }); 

    //İmzacılar
    getUsers()
    .then((response) => {
      this.state.internalSignersColumns.filter(item => item.field=="userInfo").map((item) =>  {
        item.dataList=response.data;
        if(selectedValue.internalSigners!=undefined && selectedValue.internalSigners.length>0)
        this.afterDataLoaded(item,selectedValue.internalSigners); 
      })
    })
    .catch((exception) => {
      this.props.actions.setNotification("İmzacı bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getUsers exception: ' + JSON.stringify(exception));
    }); 

    //Parametre bilgileri
    getParametersByGroupCodes(parameterGroups)
    .then((response) => {
      const datas=response.data;
      for (let i = 0; i < datas.length; i++) {
        const parameter = datas[i];
        switch (parameter.groupCode) {
          case 'SUFFICIENT_NUMBER_OF_SIGNERS':
            this.setState({sufficientSignerList : parameter.parameters});
            break;
          case 'SIGN_TYPE':
            this.state.internalSignersColumns.filter(item => item.field=="signType").map((item) =>{
              item.dataList=parameter.parameters;
              if(selectedValue.internalSigners!=undefined && selectedValue.internalSigners.length>0)
                this.afterDataLoaded(item,selectedValue.internalSigners); 
            });
            break;
          case 'NOTIFICATION_TYPE':
            this.setState({notificationTypesList : parameter.parameters});
            break;
          case 'END_PROCESS_NOTIFICATION':
            this.setState({endProcessNotificationTypeList : parameter.parameters});
            break;
          case 'COMPLETED_PROCESS':
            this.setState({endProcessActionsList : parameter.parameters,isEndProcessLoaded:true});
            break;
          default:
            break;
        }
      }
    })
    .catch((exception) => {
      this.props.actions.setNotification("Parametre bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getParametersByGroupCodes exception: ' + JSON.stringify(exception));
    }); 

  }

  afterDataLoaded(currentItem,processData) { 
    let field=currentItem.field;
    let dataList=currentItem.dataList;
    let keyField=currentItem.keyField;
    let valueField=currentItem.valueField;

    for (let i = 0; i < processData.length; i++) {   
      for (let y = 0; y < dataList.length; y++) {
        const element = dataList[y];
        if(element[keyField]===processData[i][field][keyField])
          processData[i][field][valueField]=element[valueField];
      }  
    }
 
  }

  handleChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    this.setState({ [fieldName]: fieldValue });
  };

  processGroupChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.value;

    //Süreç Türü 
    this.fillProcessTypeList(fieldValue);   

    this.setState({ [fieldName]: fieldValue ,processType:this.guidEmpty});
  };

  fillProcessTypeList(processGroupId){
    //Süreç Türü    
    getProcessType(processGroupId)
    .then((response) => {
      this.setState({processTypesList : response.data,processType:this.guidEmpty});
    })
    .catch((exception) => {
      this.props.actions.setNotification("Süreç türü bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
      console.log('getProcessTypes exception: ' + JSON.stringify(exception));
    }); 
  }

  handleCheckBoxChange = event => {
    const fieldName = event.target.name;
    const fieldValue = event.target.checked;

    this.setState({ [fieldName]: fieldValue });
  };

  handleRadioSignOrder = event => {
    this.setState({ signOrder: event.target.value });
  };

  handleOnGridChange(data,id) {
    this.setState({ [id]: data });
  }

  handleValidation(rows,newRow) {
    const isPresent = rows.some(item => item.userInfo.id === newRow.userInfo.id);

    if(isPresent){
      this.props.actions.setNotification('Aynı kullanıcıyı birden fazla kez tanımlayamazsınız.', 'error');
      return true;
    }
    return false;
  }

  handleEndProcessActionChange(item) {
    this.setState({ endOperationAction: item });
  }

  handleSave = () => {
    if(this.state.editModelPage){
      this.UpdateRecord();
    }
    else{
      this.InsertRecord();
    }
  };

  InsertRecord = () => {
    const {templateName,processGroup,processType,fileReadValidationCheck,signOrder,sufficientSigner,internalSigners
      ,notificationType,endProcessNotificationType,endOperationAction}=this.state;
  
      const newProcess={
        name:templateName,
        processGroup:processGroup,
        processType:processType,
        isReadBeforeSign:fileReadValidationCheck,
        signOrder:signOrder,
        sufficientSigner:sufficientSigner,
        internalSigners:internalSigners,
        externalSigners:[],
        notificationType:notificationType,
        endProcessNotificationType:endProcessNotificationType,
        endOperationAction:endOperationAction
      }
  
      apiDashBoardService.createProcessTemplate(newProcess)
        .then((responseJson) => {
          this.props.closeEditPage();
          console.log(responseJson);
        }).catch((error) => {
          if (!_.isNil(error.Message)) {
            this.props.actions.setNotification(error.Message, 'error');
          } else {
            this.props.actions.setNotification('Süreç şablonu oluşturulamadı.Girmiş olduğunuz değerlerde sorun olabilir.', 'error');
          }
        })
        .finally(()=>{
          this.setState({loading: false});
        });
  }

  UpdateRecord = () => {
    const {templateName,processGroup,processType,fileReadValidationCheck,signOrder,sufficientSigner,internalSigners
      ,notificationType,endProcessNotificationType,endOperationAction,id}=this.state;
  
      let newProcess={
        name:templateName,
        processGroup:processGroup,
        processType:processType,
        isReadBeforeSign:fileReadValidationCheck,
        signOrder:signOrder,
        sufficientSigner:sufficientSigner,
        internalSigners:internalSigners,
        externalSigners:[],
        notificationType:notificationType,
        endProcessNotificationType:endProcessNotificationType,
        endOperationAction:endOperationAction
      }
  
      apiDashBoardService.updateProcessTemplate(id,newProcess)
        .then((responseJson) => {
          this.props.closeEditPage();
          console.log(responseJson);
        }).catch((error) => {
          if (!_.isNil(error.Message)) {
            this.props.actions.setNotification(error.Message, 'error');
          } else {
            this.props.actions.setNotification('Süreç şablonu oluşturulamadı.Girmiş olduğunuz değerlerde sorun olabilir.', 'error');
          }
        })
        .finally(()=>{
          this.setState({loading: false});
        });
  }

  handleCancel = () => {
    this.props.closeEditPage();
  }

  render() {
    const { templateName,processGroup,processType,processGroupsList,processTypesList,fileReadValidationCheck,signOrder
      ,sufficientSigner,sufficientSignerList,internalSigners,internalSignersColumns,internalSignersColumnsVisiblity
      ,notificationType,notificationTypesList,endProcessNotificationType,endProcessNotificationTypeList,endOperationAction,endProcessActionsList,isEndProcessLoaded} = this.state;

    return (
      <div>
      <ScreenContainer>
      <Box sx={{ width: '100%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>        
            <div className="headerStyle"><h4>Süreç İşlem Tanımı</h4></div>
            <div className='row'>
            <div className="component col-12 col-sm-4">
              <InputLabel id="template-label" style={styles.label}>Süreç Şablon Adı</InputLabel>
              <TextField className='customInputText' sx={styles.textField} labelId="template-label" id="templateNameText" name="templateName" value={templateName} variant="outlined" onChange={this.handleChange} placeholder="Süreç Şablon Adı"/>
            </div>
            <div className='col-12 col-sm-8'></div>
            </div>

            {/* <div className="component">
              <FormControlLabel control={<Checkbox checked={fileReadValidationCheck} 
              onChange={this.handleCheckBoxChange} name="fileReadValidationCheck" />} label={<div style={styles.formLabel}>Dosya İmzalamadan Önce Görüntüle(Sadece PDF)</div>}/>
            </div> */}

            <div className='component row'>
              <div className='sameLine col-12 col-sm-4'>
                <InputLabel id="processGroupLabel" style={styles.label}>Süreç Grubu</InputLabel>
                <Select
                  fullWidth
                  labelId="processGroupLabel"
                  id="processGroupSelect"
                  className='customSelect'
                  value={processGroup}
                  name="processGroup"
                  style={styles.selectField}
                  onChange={this.processGroupChange}>
                  {processGroupsList.map((pGroup) => (
                    <MenuItem value={pGroup.id}>
                      <div style={styles.selectField}>{pGroup.name}</div>
                    </MenuItem>
                  ))}
                </Select>                
              </div>
              <div className='sameLine col-12 col-sm-4'>
                <InputLabel id="processTypeLabel" style={styles.label}>Süreç Türü</InputLabel>
                <Select
                  fullWidth
                  labelId="processTypeLabel"
                  id="processTypeSelect"
                  className='customSelect'
                  value={processType}
                  name="processType"
                  style={styles.selectField}
                  onChange={this.handleChange}>
                  {processTypesList.map((pType) => (
                    <MenuItem value={pType.id}>
                      <div style={styles.selectField}>{pType.processTypeName}</div>
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div> 
                  
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle"><h4>Süreç İmzalama Sırası</h4></div>
            <div className='component row'>
            <div className='sameLine col-12 col-sm-4'>
                <InputLabel style={styles.label}>Süreç Grubu</InputLabel>
                <Select
                  fullWidth
                  id="sufficientSignerSelect"
                  className='customSelect'
                  value={sufficientSigner}
                  name="sufficientSigner"
                  style={styles.selectField}
                  onChange={this.handleChange}
                >
                  {sufficientSignerList.map((item) => (
                    <MenuItem value={item.parameterValue}>
                      <div style={styles.selectField}>{item.parameterName}</div>
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div className='sameLine col-12 col-sm-4'>
                <RadioGroup
                  name="signOrderRadioGrpoup"
                  value={signOrder}
                  onChange={this.handleRadioSignOrder}>
                  <FormControlLabel value="1" control={<Radio />} label={<div style={styles.formLabel}>Listedeki Kullanıcılar Girilen Sırayla İmzalasın</div>}/>
                  <FormControlLabel value="2" control={<Radio />} label={<div style={styles.formLabel}>Listedeki Kullanıcılar Sıra Olmadan İmzalayabilsin</div>} />
                </RadioGroup>
              </div>
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle"><h4>İmzacı Ekle</h4></div>
            <div className='component'>
              {(!this.props.editPage||internalSigners.length>0)&&
              <SimpleEditGrid rows={internalSigners} columns={internalSignersColumns} columnVisibilityModel={internalSignersColumnsVisiblity} rowsReOrder
              gridHeight={400} 
              dialogTitle="İmzacı Ekle" 
              onGridChange = {(e) => this.handleOnGridChange(e,"internalSigners")}
              validation={(a,b)=>this.handleValidation(a,b)}/>}
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass}>
            <div className="headerStyle" style={{marginTop: '83px'}}><h4>Bilgilendirme</h4></div>
            <div className='component row'>
              <div className='sameLine col-12 col-sm-4'>
              <InputLabel id="notificationTypeLabel" style={styles.label}>Bilgilendirme Türü</InputLabel>
              <Select
                fullWidth
                className='customSelect'
                labelId="notificationTypeLabel"
                id="notificationTypeSelect"
                value={notificationType}
                name="notificationType"
                style={styles.selectField}
                onChange={this.handleChange}>
                {notificationTypesList.map((nType) => (
                  <MenuItem value={nType.parameterValue}>
                    <div style={styles.selectField}>{nType.parameterName}</div>
                  </MenuItem>
                ))}
              </Select>
              </div>
              <div className='sameLine col-12 col-sm-4'>
              <InputLabel id="endNotificationTypeLabel" style={styles.label}>Süreç Sonu Bilgilendirme</InputLabel>
              <Select
                fullWidth
                className='customSelect'
                labelId="endNotificationTypeLabel"
                id="endNotificationTypeSelect"
                value={endProcessNotificationType}
                name="endProcessNotificationType"
                style={styles.selectField}
                onChange={this.handleChange}>
                {endProcessNotificationTypeList.map((nType) => (
                  <MenuItem value={nType.parameterValue}>
                    <div style={styles.selectField}>{nType.parameterName}</div>
                  </MenuItem>
                ))}
              </Select>
              </div>
            </div>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <div>
            {(!this.props.editPage||!_.isEmpty(endOperationAction))&&isEndProcessLoaded&&
            <EndProcessAction handleEndProcessActionChange = {(e) => this.handleEndProcessActionChange(e)}  endOperationAction={endOperationAction} endProcessActionsList={endProcessActionsList}/>}
          </div>
        </Grid>

        <Grid item xs={12}>
          <Box sx={styles.boxClass} className="row">
            <div className='col'></div>
            <div className='sameLine col-auto'>
              <Button onClick={this.handleSave} sx={styles.saveButton} variant="contained" >
                Kaydet
              </Button>
            </div>
            <div className='sameLine col-auto'>
              <Button onClick={this.handleCancel} sx={styles.cancelButton} variant="contained" >
                İptal
              </Button>
            </div>
          </Box>
        </Grid>

      </Grid>
    </Box>
    </ScreenContainer>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(Actions, dispatch)
});

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
)(NewProcessTemplate);